import React from 'react'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Contact() {

    const notify = () => toast.success("Wow so easy!");

    return (
        <>
            <div className='contact container my-5'>
                <div className='row'>
                    <div className='col-lg-6 col-md-6 col-sm-12 left'>
                    <lottie-player src="https://assets4.lottiefiles.com/packages/lf20_zj3qnsfs.json"  background="transparent"  speed="1" id='contactimg' loop  autoplay></lottie-player>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 right'>
                        <h3>Get in touch</h3>
                        <p>Email 💌 : <span>suryawanshisanket69@gmail.com</span> | Contact 📞 : <span>+917666294825</span> </p>
                        <form className='my-5' method='POST' action='https://formspree.io/f/mwkjbpva'>
                            <div class="form-row">
                                <div class="col">
                                <input type="text" name='FName' class="form-control" required placeholder="Full Name" />
                                </div>
                                <div class="col">
                                <input type="email" name='email' class="form-control" required placeholder="Email ID" />
                                </div>
                            </div>
                            <div class="form-group my-4">
                                <textarea class="form-control" name='message' id="exampleFormControlTextarea1" placeholder='Enter Your Message Here !!' rows="3" required></textarea>
                            </div>
                            <button onClick={notify} type="submit" class="btn btn-success text-white">SEND 🎯</button>
                            <ToastContainer />
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Contact